import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";
import { flipCandidatePrivacy } from "../actions";

export class FlipCandidatePrivacy extends React.PureComponent {
  handleChangeAction = () => {
    this.props.changeAction(false);
  };

  handleConfirm = () => {
    this.props.onFlipCandidatePrivacy(this.props.candidateId);
    this.props.changeAction(false);
  };

  render() {
    const { candidatePrivate } = this.props;

    return (
      <div>
        <Modal.Header>
          <h4>{candidatePrivate ? "Remove Privacy" : "Make Private"}</h4>
        </Modal.Header>
        <Modal.Body>
          <p>
            {candidatePrivate
              ? "When you remove privacy, the candidate will no longer only be visible to users on your account with the Admin access role. Any users with access to results for this job will be able to see this candidate's information Do you want to remove privacy for this candidate?"
              : "When you make a candidate private, they will only be visible to users on your account with the Admin access role. Do you want to make this candidate private?"}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={this.handleChangeAction}
            id={
              candidatePrivate
                ? "cancelRemoveCandidatePrivacy"
                : "cancelMakeCandidatePrivate"
            }
            variant="outline-primary"
            className="btn-cancel"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleConfirm}
            id={
              candidatePrivate
                ? "confirmRemoveCandidatePrivacy"
                : "confirmMakeCandidatePrivate"
            }
          >
            Yes
          </Button>
        </Modal.Footer>
      </div>
    );
  }
}

FlipCandidatePrivacy.propTypes = {
  changeAction: PropTypes.func,
  candidateId: PropTypes.string,
  candidatePrivate: PropTypes.bool,
  onFlipCandidatePrivacy: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  onFlipCandidatePrivacy: (candidateId) =>
    dispatch(flipCandidatePrivacy(candidateId)),
});

export default connect(undefined, mapDispatchToProps)(FlipCandidatePrivacy);
